import axios from "axios";
var qs = require("qs");

/**
 * Class to make a unique interface
 */
export class ErrorAPI {
  constructor(e) {
    this._error = e;

    // HTTP STATUS
    this.httpStatusCode = -1;
    this.httpStatusDescription = -1;

    // API STATUS CODE (Default -1.. Something is wrong with the request)
    this.resultCode = -1;
    this.resultDescription = "An error occurred";
    this.warnings = [];
    this.errors = [];

    if (e.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      this.httpStatusCode = e.response.status;
      this.httpStatusDescription = e.response.statusText;
      this.httpStatusCodeDescription = e.response.statusText;
      this.resultCode = e.response.data.result.status;
      this.resultDescription = e.response.data.result.message;
      this.errors = e.response.data.errors || [];
      this.warnings = e.response.data.warnings || [];
    } else if (e.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      this.httpStatusCode = e.request.status;
      this.httpStatusDescription = e.request.statusText;
      this.resultCode = -1;
      this.resultDescription = "No response received";
    }
    /* else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
            this.status = -1;
            this.statusMessage = "";
        }*/
  }

  getHTTPStatusCode() {
    return this.httpStatusCode;
  }

  getHTTPStatusDescription() {
    return this.httpStatusDescription;
  }

  getResultCode() {
    return this.resultCode;
  }

  getResultDescription() {
    return this.resultDescription;
  }

  getErrors() {
    return this.errors;
  }

  getWarnings() {
    return this.warnings;
  }
}

axios.interceptors.request.use(config => {
  config.paramsSerializer = params => {
    // Qs is already included in the Axios package
    return qs.stringify(params, {
      arrayFormat: "brackets",
      encode: false
    });
  };

  return config;
});

// Add a response interceptor
axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    // Do something with response error
    return Promise.reject(new ErrorAPI(error));
  }
);

let scopes = {};

export function getCancelToken(scopeName) {
  return scopeName in scopes ? scopes[scopeName].cancelToken : null;
}

export function createAxiosInstance(scopeName, options = {}) {
  let instance = axios.create();
  let useProxyApi = options.proxyApi || false;

  instance.interceptors.request.use(config => {
    if (useProxyApi) {
      if (config.params == null) config.params = {};
      config.params._urlProxy = config.url;
      config.url = "/api/proxy";
    }

    config.cancelToken = getCancelToken(scopeName).token;
    config.paramsSerializer = params => {
      // Qs is already included in the Axios package
      return qs.stringify(params, {
        arrayFormat: "brackets",
        encode: false
      });
    };
    return config;
  });

  instance.interceptors.response.use(
    function(response) {
      // Do something with response data
      return response;
    },
    function(error) {
      // Do something with response error
      return Promise.reject(new ErrorAPI(error));
    }
  );
  return {
    instance: instance,
    options: options,
    cancelToken: axios.CancelToken.source()
  };
}

/**
 *
 * @return Axios
 */
export function cancelRequest(scopeName) {
  if (scopeName in scopes) {
    scopes[scopeName].cancelToken.cancel();
    // Generating other token...

    scopes[scopeName].cancelToken = axios.CancelToken.source();
  }
}

export function cancelAllRequests() {
  for (let scopeName in scopes) {
    scopes[scopeName].cancelToken.cancel();
    // Generating other token...
    scopes[scopeName].cancelToken = axios.CancelToken.source();
  }
}

export function getRequestScope({
  scopeName = "default",
  cancelPreviousRequest = false,
  options = {}
}) {
  if (scopeName in scopes) {
    if (cancelPreviousRequest) {
      cancelRequest(scopeName);
    }

    // REFACTOR: for some reason, proxy api not work here, possible a BREAKING CHANGE
    return scopes[scopeName].instance;
  }

  scopes[scopeName] = createAxiosInstance(scopeName, options);
  return scopes[scopeName].instance;
}

// Definition of scopes..
scopes.default = createAxiosInstance("default");
scopes.api = createAxiosInstance("api", { proxyApi: true });
